module.exports = __webpack_public_path__ + "static/img/15.cfae37a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/gameNewPic/15.jpg
// module id = 9vfy
// module chunks = 1